import { ResourceModel, Field } from '@smartsoftware/reflex-core';
import { DexResourceModel } from '../abstracts/dexResource.model';

export class ClientUser extends DexResourceModel {
    @Field(String)
    public client_uuid?:string | null = null;

    @Field(String)
    public successAccount_uuid?:string | null = null;

    constructor(data?: any) {
        super();
        this.mapData(data);
    }

}